/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import {
  StyledCircleIcon,
  CarouselContainer,
  NavigationContainer,
} from "./styles";

export const CarouselPage = ({ data, showSlider = false }) => {
  const [imagePath, setImagePath] = React.useState(data[0]?.image);

  const handleChange = (image) => {
    setImagePath(image);
  };

  return (
    <React.Fragment>
      <CarouselContainer>
        <img
          src={imagePath}
          alt="brand banner"
          style={{ height: "100%", width: "100%", objectFit: "cover" }}
        />
        {showSlider && (
          <NavigationContainer>
            {data?.map((item) => {
              return (
                <div key={item?.id}>
                  <StyledCircleIcon onClick={() => handleChange(item?.image)} />
                </div>
              );
            })}
          </NavigationContainer>
        )}
      </CarouselContainer>
    </React.Fragment>
  );
};
